module.exports = __webpack_public_path__ + "media/images/element/22-92160b66bf2881c0e8d1cc808705feee.svg";